'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Table = require('react-bootstrap/lib/Table');

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryReportTable = function (_Component) {
  _inherits(BinaryReportTable, _Component);

  function BinaryReportTable() {
    _classCallCheck(this, BinaryReportTable);

    return _possibleConstructorReturn(this, (BinaryReportTable.__proto__ || Object.getPrototypeOf(BinaryReportTable)).apply(this, arguments));
  }

  _createClass(BinaryReportTable, [{
    key: 'render',
    value: function render() {
      var tableHeader = null;
      var tableBody = null;
      var columns = [];
      var emptyColSpan = 1;
      var rowData = [];

      // Headers
      if (this.props.headers) {
        var tempHeads = [];
        var headerRows = [];
        if (this.props.headers.multiple && this.props.headers.data.length > 0) {
          tempHeads = this.props.headers.data;
        } else {
          tempHeads.push(this.props.headers);
        }
        if (tempHeads.length > 0) {
          tempHeads.forEach(function (row) {
            var headers = [];
            row.forEach(function (item) {
              if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item.value !== null) {
                var style = item.style !== null ? item.style : '';
                var colSpan = item.colSpan ? item.colSpan : 1;
                headers.push(_react2.default.createElement(
                  'th',
                  { style: style, colSpan: colSpan },
                  item.value
                ));
              } else {
                headers.push(_react2.default.createElement(
                  'th',
                  null,
                  item
                ));
              }
            });
            headerRows.push(_react2.default.createElement(
              'tr',
              null,
              headers
            ));
          });
        }
        tableHeader = _react2.default.createElement(
          'thead',
          null,
          headerRows
        );
      }
      // Rows
      if (this.props.rows.length > 0) {
        this.props.rows.forEach(function (item) {
          if (item.data && item.data[0].value) {
            columns = [];
            item.data.forEach(function (row) {
              if (row.cellStyle) {
                columns.push(_react2.default.createElement(
                  'td',
                  { style: row.cellStyle },
                  row.value
                ));
              } else {
                columns.push(_react2.default.createElement(
                  'td',
                  null,
                  row.value
                ));
              }
            });
            rowData.push(_react2.default.createElement(
              'tr',
              null,
              columns
            ));
          } else {
            columns = [];
            item.data.forEach(function (row) {
              columns.push(_react2.default.createElement(
                'td',
                null,
                row
              ));
            });
            rowData.push(_react2.default.createElement(
              'tr',
              null,
              columns
            ));
          }
        });
        tableBody = _react2.default.createElement(
          'tbody',
          null,
          rowData
        );
      } else {
        columns = [];
        if (this.props.headers) {
          emptyColSpan = this.props.headers.length;
        }
        columns.push(_react2.default.createElement(
          'td',
          { colSpan: emptyColSpan },
          'No records to display!'
        ));
        rowData.push(_react2.default.createElement(
          'tr',
          null,
          columns
        ));
        tableBody = _react2.default.createElement(
          'tbody',
          null,
          rowData
        );
      }
      return _react2.default.createElement(
        _Table2.default,
        { responsive: true },
        tableHeader && tableHeader,
        tableBody && tableBody
      );
    }
  }]);

  return BinaryReportTable;
}(_react.Component);

BinaryReportTable.propTypes = {
  headers: _propTypes2.default.array.isRequired,
  rows: _propTypes2.default.array.isRequired
};
BinaryReportTable.defaultProps = {
  headers: [],
  rows: []
};
exports.default = BinaryReportTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryReportTable/BinaryReportTable.js
// module id = 2191
// module chunks = 1